<div class="query-container">
  <form [formGroup]="queryForm" (ngSubmit)="onExecuteQuery()">
    <mat-form-field appearance="fill" class="workspace-select">
      <mat-label>Select Workspace</mat-label>
      <mat-select formControlName="workspace">
        @for (workspace of workspaces; track workspace) {
          <mat-option
            [value]="workspace.id">
            {{workspace.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="query-input">
      <mat-label>Kusto Query</mat-label>
      <textarea matInput
        formControlName="query"
        placeholder="Enter your Kusto query here..."
      rows="6"></textarea>
    </mat-form-field>

    <button mat-raised-button
      color="primary"
      type="submit"
      [disabled]="isLoading || !queryForm.valid">
      Execute Query
    </button>
  </form>

  @if (isLoading) {
    <mat-progress-bar mode="indeterminate">
    </mat-progress-bar>
  }

  @if (queryResult) {
    <div class="query-results">
      <table mat-table [dataSource]="queryResult.tables[0].rows">
        @for (column of queryResult.tables[0].columns; track column; let i = $index) {
          <ng-container [matColumnDef]="column.name">
            <th mat-header-cell *matHeaderCellDef>{{column.name}}</th>
            <td mat-cell *matCellDef="let row">{{row[i]}}</td>
          </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="getColumnNames()"></tr>
        <tr mat-row *matRowDef="let row; columns: getColumnNames();"></tr>
      </table>
    </div>
  }
</div>
